<template>
  <b-button
    :class="`raised ${styleClasses}`"
    :variant="variant"
    @click="sendEmail()"
  >
    <font-awesome-icon icon="envelope" />
    {{ text || email }}
  </b-button>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

library.add(faEnvelope);

export default {
  props: {
    email: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
    styleClasses: String,
    variant: String,
  },
  methods: {
    sendEmail() {
      document.location = `mailto:${this.email}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/misc/EmailButton.vue